var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3C3 2.46957 3.21071 1.96086 3.58579 1.58579C3.96086 1.21071 4.46957 1 5 1H14.982C15.5124 1.00011 16.021 1.2109 16.396 1.586L20.414 5.604C20.7891 5.97899 20.9999 6.48761 21 7.018V21C21 21.5304 20.7893 22.0391 20.4142 22.4142C20.0391 22.7893 19.5304 23 19 23H5C4.46957 23 3.96086 22.7893 3.58579 22.4142C3.21071 22.0391 3 21.5304 3 21V3ZM5 2.5C4.86739 2.5 4.74021 2.55268 4.64645 2.64645C4.55268 2.74021 4.5 2.86739 4.5 3V21C4.5 21.1326 4.55268 21.2598 4.64645 21.3536C4.74021 21.4473 4.86739 21.5 5 21.5H19C19.1326 21.5 19.2598 21.4473 19.3536 21.3536C19.4473 21.2598 19.5 21.1326 19.5 21V8.5H15.5C14.9696 8.5 14.4609 8.28929 14.0858 7.91421C13.7107 7.53914 13.5 7.03043 13.5 6.5V2.5H5ZM15 2.5V6.5C15 6.63261 15.0527 6.75979 15.1464 6.85355C15.2402 6.94732 15.3674 7 15.5 7H19.5C19.4956 6.87356 19.4434 6.7535 19.354 6.664L15.336 2.646C15.2465 2.55658 15.1264 2.50441 15 2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.dcf454fd39f2b3a3e5250c927a694226.svg";
export { ForwardRef as ReactComponent };